import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';
import { ModalController } from '@ionic/angular';
import { InfozonemodalComponent } from '../../components/infozonemodal/infozonemodal.component'

@Component({
    selector: 'app-infozonebutton',
    templateUrl: './infozonebutton.component.html',
    styleUrls: ['./infozonebutton.component.scss'],
    standalone: false
})
export class InfozonebuttonComponent implements OnInit {
  @Input() infozone: any;

  private assetUrl = inject(AssetUrlService);

  constructor(public modalController:ModalController, public data: DataService) { }

  ngOnInit() {}

  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: InfozonemodalComponent,
      animated: false,
      htmlAttributes: { 'aria-label': 'Info: ' + (that.infozone?.title || '') },
      componentProps: {
        infozone: that.infozone,
        basepath: that.assetUrl.getMediaBase()
      }
    });
    return await modal.present();
  }

  get thumbpath(){
    return encodeURI(this.assetUrl.mediaUrl(this.infozone.thumb));
  }
  
}